import { Component } from '@angular/core';

@Component({
    selector: 'diana-not-available-on-mobile-message',
    templateUrl: './not-available-on-mobile-message.component.html',
    styleUrls: ['./not-available-on-mobile-message.component.scss'],
    standalone: false
})
export class NotAvailableOnMobileMessageComponent {

  constructor() { }

}
